import React from 'react';
import CopyButton from '../CopyButton';
import { areaCodeToTimezoneMap } from './areaCodeMap';
import { offsetMap } from './offsetMap';
import { extractAreaCode } from 'services/utils/generic.methods';


const OffSetToTimezone = ({ offset, phoneNumber }) => {
  if (phoneNumber) {
    const areaCode = extractAreaCode(phoneNumber);
    if (areaCode && areaCodeToTimezoneMap[areaCode]) {
      return <CopyButton value={areaCodeToTimezoneMap[areaCode]} />;
    }
  }

  const key = String(offset);
  const data = offsetMap[key] || 'N/A';
  return <CopyButton value={data} />;
};

export default OffSetToTimezone;
